import React from "react";
import ProgressBar from "../Helpers/Progress";

const DownloadVideoAnimaton = ({ downloadPercentage }) => {
  return (
    <div
      className={
        "share-item " +
        (downloadPercentage > 0 && downloadPercentage !== 100 ? "" : "d-none")
      }
    >
      <div
        className={
          downloadPercentage > 0 && downloadPercentage !== 100
            ? "btn-hover"
            : "d-none"
        }
      >
        <ProgressBar
          strokeWidth="4"
          sqSize="20"
          percentage={downloadPercentage}
        />
      </div>
    </div>
  );
};
export default DownloadVideoAnimaton;
